// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_courseTimesForm__qonjH {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.styles_courseTimesForm__qonjH .styles_dayTimeRow__VYxSi {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.styles_courseTimesForm__qonjH .styles_dayTimeRow__VYxSi .styles_dayLabel__kV4ON {
  font: var(--typography-body-m-medium);
  color: var(--color-black);
  text-align: left;
}
.styles_courseTimesForm__qonjH .styles_dayTimeRow__VYxSi .styles_timeSelectors__gUNzT {
  display: flex;
  width: 100%;
  gap: 12px;
}
@media (min-width: 768px) {
  .styles_courseTimesForm__qonjH .styles_dayTimeRow__VYxSi .styles_timeSelectors__gUNzT {
    gap: 16px;
  }
}
.styles_courseTimesForm__qonjH .styles_dayTimeRow__VYxSi .styles_errorText__dcbUr {
  font: var(--typography-body-s-regular);
  color: var(--color-error);
  margin-top: 4px;
}

.styles_formActions__zk8Ek {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
  gap: 12px;
}
.styles_formActions__zk8Ek .styles_saveButton__FIv38,
.styles_formActions__zk8Ek .styles_backButton__1d7Pl {
  width: 100%;
}
@media (min-width: 768px) {
  .styles_formActions__zk8Ek {
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/add-course-times/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAAJ;AAEI;EACE,qCAAA;EACA,yBAAA;EACA,gBAAA;AAAN;AAGI;EACE,aAAA;EACA,WAAA;EACA,SAAA;AADN;ACdE;EDYE;IAMI,SAAA;EAAN;AACF;AAGI;EACE,sCAAA;EACA,yBAAA;EACA,eAAA;AADN;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AAHF;AAKE;;EAEE,WAAA;AAHJ;ACpCE;ED8BF;IAaI,SAAA;EAHF;AACF","sourcesContent":["@import \"mixins\";\n.courseTimesForm {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  .dayTimeRow {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n\n    .dayLabel {\n      font: var(--typography-body-m-medium);\n      color: var(--color-black);\n      text-align: left;\n    }\n\n    .timeSelectors {\n      display: flex;\n      width: 100%;\n      gap: 12px;\n\n      @include md{\n        gap: 16px;\n      }\n    }\n\n    .errorText {\n      font: var(--typography-body-s-regular);\n      color: var(--color-error);\n      margin-top: 4px;\n    }\n  }\n}\n\n.formActions {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 8px;\n  gap: 12px;\n\n  .saveButton,\n  .backButton {\n    width: 100%;\n  }\n\n  @include md{\n    gap: 16px;\n  }\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"courseTimesForm": `styles_courseTimesForm__qonjH`,
	"dayTimeRow": `styles_dayTimeRow__VYxSi`,
	"dayLabel": `styles_dayLabel__kV4ON`,
	"timeSelectors": `styles_timeSelectors__gUNzT`,
	"errorText": `styles_errorText__dcbUr`,
	"formActions": `styles_formActions__zk8Ek`,
	"saveButton": `styles_saveButton__FIv38`,
	"backButton": `styles_backButton__1d7Pl`
};
export default ___CSS_LOADER_EXPORT___;
